export default "__VITE_ASSET__CAq422Lx__"